export default __webpack_public_path__ + "static/media/card-06.37f73941.svg";